"use client";

import { Suspense } from "react";
import dynamic from "next/dynamic";

const LoginContent = dynamic(() => import("@/app/login/components/Login"), {
  ssr: false,
});

export default function LocaleLoginPage() {
  return (
    <Suspense
      fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}
    >
      <LoginContent />
    </Suspense>
  );
}
